const imgData = [
  "Reactjs",
  "Reactnative",
  "Redux",
  "node",
  "express",
  "Javascript",
  "github",
  "Html",
  "css",
  "Mongodb",
  "Mysql",
  "Postgres",
  "java",
  "oops",
];

export default imgData;
